import React from 'react';
import Skeleton from 'react-loading-skeleton';
import dayjs from 'dayjs';
import { DateRangePicker } from 'components';
import { BusinessDayLabel, BusinessDayLayout } from './styles';

interface IBusinessDayLayoutProps {
  isLoading: boolean;
  startDate: string;
  endDate: string;
  setDates: (dates: string[]) => void;
}

const BusinessDaySection = ({ isLoading, startDate, endDate, setDates }: IBusinessDayLayoutProps) => (
  <BusinessDayLayout>
    <BusinessDayLabel>{isLoading ? <Skeleton width={90} /> : 'Business Days'}</BusinessDayLabel>
    <DateRangePicker
      data-cy="business-days"
      fluidWidth={false}
      inputHeight="small"
      onSubmit={setDates}
      pickerPosition="right"
      startDate={dayjs(startDate, 'YYYY-MM-DD').format('MM-DD-YYYY')}
      endDate={dayjs(endDate, 'YYYY-MM-DD').format('MM-DD-YYYY')}
      submitLabel="apply"
    />
  </BusinessDayLayout>
);

export default BusinessDaySection;
